'use client'

import { useState } from 'react'
import { Menu } from 'lucide-react'
import { MobileNav } from '@sifly/shared-ui/navigation'
import { track } from '@/lib/analytics'
import type { Tenant, NavLink } from '@sifly/shared-types'

export function MobileNavToggle({ tenant, links }: { tenant: Tenant; links: NavLink[] }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <button
        onClick={() => setIsOpen(true)}
        className="md:hidden text-[var(--color-text-secondary)] hover:text-[var(--color-text-primary)] transition-colors"
        aria-label="Open menu"
      >
        <Menu size={20} />
      </button>
      <MobileNav
        links={links}
        tenant={tenant}
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onLinkClick={(meta) => track('nav_click', meta)}
      />
    </>
  )
}
